import { Tooltip } from '@mui/material';

const PatchTooltip = ({ children, ...props }) => (
    <Tooltip {...props}>
        <span style={({display: 'inline-block', width: '100%'})}>{children}</span>
    </Tooltip>
);

export default PatchTooltip;
